<template>
    <v-menu ref="menu" v-model="menu" class="rooms-select" :close-on-content-click="false" attach :max-width="520">
        <template v-slot:activator="{props}">
            <v-text-field
                :model-value="roomsLabel"
                :single-line="singleLine"
                variant="outlined"
                :bg-color="backgroundColor"
                :rounded="rounded"
                :prepend-inner-icon="showIcon ? prependInnerIcon : null"
                hide-details
                readonly
                data-cy="rooms-selector"
                :label="getLabel"
                :placeholder="$t('room', 2).charAt(0).toUpperCase() + $t('room', 2).slice(1)"
                :class="{caption: $breakpoint.smAndDown}"
                v-bind="props"
                density="comfortable"
            />
        </template>
        <v-card class="rooms-drop-down" max-width="fit-content" max-height="425" color="white" theme="light">
            <rooms-select-list v-model="rooms">
                <v-btn color="primary" variant="text" @click="menu = false">OK</v-btn>
            </rooms-select-list>
        </v-card>
    </v-menu>
</template>

<script lang="ts">
    import {Component, Prop, VModel, Vue, Watch} from 'vue-facing-decorator'

    import RoomsSelectList from '@/components/search/forms/RoomsSelectList.vue'

    @Component({
        components: {
            RoomsSelectList,
        },
    })
    export class RoomsSelect extends Vue {
        @VModel({default: []}) rooms
        @Prop({default: false}) outlined
        @Prop({default: true}) singleLine
        @Prop({default: true}) showIcon
        @Prop({default: 'mdi-account'}) prependInnerIcon
        @Prop({default: 'white'}) backgroundColor
        @Prop({default: false, type: Boolean}) rounded

        menu = false

        beforeUnmount() {
            this.$refs.menu.activatorNode = null
        }

        removeRoom(index) {
            this.rooms.splice(index, 1)
        }

        addRoom() {
            this.rooms.push({adults: this.isDisabled ? 1 : 2, childrenAges: []})
        }

        get roomsLabel() {
            if (!this.rooms.length) return ''
            const touristsTotal = this.rooms.reduce((total, tourists) => {
                return total + tourists.adults + tourists.childrenAges.length
            }, 0)
            return `${this.rooms.length} ${this.$t('room', this.rooms.length)} ${touristsTotal} ${this.$t(
                'guest',
                touristsTotal
            )}`
        }

        get isDisabled() {
            return authStore.user.isEmployeeOrExternalCorp || this.rooms.length > 19
        }

        get getLabel() {
            return `${this.$t('room', this.rooms.length)}`
        }
    }

    export default RoomsSelect
</script>

<style scoped lang="scss">
    @media (max-width: 960px) {
        .rooms-drop-down {
            max-width: 100% !important;
        }
    }
</style>
